"use client";

import React from "react";
import { CarFront, Clock, MapPin, Truck, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  value: "15K+",
  label: "Cars Processed",
  icon: CarFront
}, {
  value: "20+",
  label: "Cities Served",
  icon: MapPin
}, {
  value: "100%",
  label: "Free Towing",
  icon: Truck
}, {
  value: "24/7",
  label: "Fast Support",
  icon: Clock
}];
export default function About() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="about" className="bg-background py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          {}
          <div ref={leftRef} className={`flex flex-col gap-8 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="space-y-4">
              <Badge variant="secondary" className="uppercase tracking-widest font-bold px-4 py-1.5 text-sm">
                Our Story
              </Badge>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tighter text-foreground leading-[1.1]">
                High-Performance <br className="hidden md:block" />
                <span className="text-primary">Junk Car Removal</span> <br className="hidden md:block" />
                Since 2017
              </h2>
            </div>

            <div className="space-y-6 text-lg text-muted-foreground leading-relaxed">
              <p>
                At Junk Car Pick Up BC, we've revolutionized the scrap vehicle industry with our lightning-fast, hassle-free removal process. Operating across British Columbia, we turn your unwanted vehicles into instant cash while ensuring environmentally responsible recycling.
              </p>
              <p>
                Our commitment to speed, transparency, and top-dollar payouts has made us the region's most trusted auto recycling partner. Whether it's a wrecked truck or an old sedan, we handle the heavy lifting so you don't have to.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button size="lg" asChild className="font-bold tracking-wide uppercase h-14 px-8">
                <Link to="/ContactPage">
                  Get Instant Quote
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
              <div className="flex items-center px-4 text-sm font-medium text-muted-foreground">
                Call us directly: <span className="text-foreground font-bold ml-2">778-385-3007</span>
              </div>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`grid grid-cols-1 sm:grid-cols-2 gap-6 transition-all duration-1000 delay-200 ease-out ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            {stats.map((stat, i) => {
            const Icon = stat.icon;
            return <Card key={stat.label} data-index={i} className="bg-primary border-none shadow-2xl overflow-hidden group hover:-translate-y-2 transition-transform duration-300">
                  <CardHeader className="pb-2">
                    <div className="size-12 rounded-lg bg-primary-foreground/10 flex items-center justify-center mb-4 group-hover:bg-primary-foreground/20 transition-colors">
                      <Icon className="size-6 text-primary-foreground" />
                    </div>
                    <CardTitle className="text-5xl font-black tracking-tighter text-primary-foreground">
                      {stat.value}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm font-bold uppercase tracking-widest text-primary-foreground/70">
                      {stat.label}
                    </p>
                  </CardContent>
                  
                  {}
                  <div className="absolute -bottom-6 -right-6 size-32 bg-primary-foreground/5 rounded-full blur-2xl pointer-events-none" />
                </Card>;
          })}
          </div>

        </div>
      </div>
    </section>;
}